import { useEffect, useState } from 'react'
import './Home.css'
import { Routes, Route } from 'react-router-dom';
import { getServices } from '../../utilities/api/services';
import SideBar from '../../components/SideBar/SideBar'
import FormList from '../../pageContent/FormList/FormList';
import IntakeForm from '../../pageContent/IntakeForm/IntakeForm';
import ProjectsContent from '../../pageContent/ProjectsContent/ProjectsContent';
import Patents from '../../pageContent/Patents/Patents';
import Trademarks from '../../pageContent/Trademarks/Trademarks';
import Welcome from '../../pageContent/Welcome/Welcome';

export default function Home({ user, clientServices, getCurrentClientServices, isMobile }) {
  const [isSideBarExpanded, setIsSideBarExpanded] = useState(true)
  const [services, setServices] = useState([])


  const getAllServices = async () => {
    try {
      const res = await getServices()
      setServices(res)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getAllServices()
    // eslint-disable-next-line
  }, [])

  return (
    <div className='Home'>
      <SideBar user={user} isSideBarExpanded={isSideBarExpanded} setIsSideBarExpanded={setIsSideBarExpanded} isMobile={isMobile}/>
      <div className='mainSection'>
        <div className={`mainContent `}>
          <Routes>
            <Route path='/' element={<Welcome 
            user={user} 
            isMobile={isMobile} />} />
            <Route path='/intakeForms' element={<FormList 
            client={user}
            getCurrentClientServices={getCurrentClientServices} 
            clientServices={clientServices} 
            isMobile={isMobile} />} />

            {['super', 'admin', 'editor'].includes(user.currentUserType) && (
                <Route path='/intakeForms/:formID' element={<IntakeForm client={user}  />} />
              )
            }
            
            <Route path='/projects' element={<ProjectsContent 
            user={user}
            isMobile={isMobile}
            services={services}  />} />

            <Route path='/patents' element={<Patents 
            user={user}
            isMobile={isMobile} />} />

            <Route path='/trademarks' element={<Trademarks 
            user={user}
            isMobile={isMobile} />} />
            
            <Route path='/*' element={<Welcome 
            user={user} 
            isMobile={isMobile} />} />
          </Routes>
        </div>
        <div id='mainNotification' className='mainNotification'></div>
      </div>
    </div>
  )
}
